import React, { Component } from 'react';
import './Main.css';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {to_d} from '../helpers';

// 10秒移動平均の最高速度・平均速度を、GPS点列から直接算出する。
// Legは全体(Practice)のave_speed/max_10s_spdのようなキャッシュ済みの値を
// 持たないため、全レコードで同じロジックにより計算して統一する。
function calcAveAndMax10s(gpses) {
  if (!gpses || gpses.length === 0) {
    return { aveSpd: 0, max10sSpd: 0 };
  }

  let total = 0;
  let window = [];
  let max10sSpd = 0;

  gpses.forEach((gps) => {
    const spd = gps._speed || 0;
    total += spd;
    window.push(spd);
    if (window.length > 10) window.shift();
    if (window.length === 10) {
      const avg10 = window.reduce((a, b) => a + b, 0) / 10;
      if (avg10 > max10sSpd) max10sSpd = avg10;
    }
  });

  return {
    aveSpd: Math.round((total / gpses.length) * 10) / 10,
    max10sSpd: Math.round(max10sSpd * 10) / 10,
  };
}

// Leg一覧のソート対象列。keyはソート用、labelは表示用ヘッダー、
// getValueは行データからソートに使う数値を取り出す
const COLUMNS = [
  { key: 'duration', label: 'Time', getValue: (r) => r.record.duration_seconds || 0 },
  { key: 'stroke', label: 'All Stroke', getValue: (r) => r.record.stroke || 0 },
  { key: 'distance', label: 'Distance', getValue: (r) => r.record.distance || 0 },
  { key: 'aveSpd', label: 'ave SPD', getValue: (r) => r.aveSpd },
  { key: 'max10s', label: 'max10s', getValue: (r) => r.max10sSpd },
  { key: 'pace100m', label: 'Split/100m', getValue: (r) => r.record.pace100m_seconds || 0 },
  { key: 'pace500m', label: 'Split/500m', getValue: (r) => r.record.pace500m_seconds || 0 },
  { key: 'stroke100m', label: 'Stroke/100m', getValue: (r) => r.record.stroke100m || 0 },
  { key: 'stroke500m', label: 'Stroke/500m', getValue: (r) => r.record.stroke500m || 0 },
];

/**
 * ローイングモード用のSummary。全体(Practice)行と、Legごとの行を
 * 1レコードずつ表示する一覧テーブル。列名クリックでLeg一覧をソートできる。
 */
export default class SummaryRowingLegs extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sortKey: null,
      sortDir: 'asc',
    };
  }

  handleSort(key) {
    this.setState((prev) => {
      if (prev.sortKey === key) {
        return { sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc' };
      }
      return { sortKey: key, sortDir: 'asc' };
    });
  }

  renderRow(label, row) {
    const { record, aveSpd, max10sSpd } = row;
    return (
      <tr key={label}>
        <td className="GridData2"><div className="Unit2">{label}</div></td>
        <td className="GridData2"><span className="summary">{to_d(record.duration_seconds)}</span></td>
        <td className="GridData2"><span className="summary">{record.stroke}</span></td>
        <td className="GridData2"><span className="summary">{record.distance}</span><span className="Unit2">m</span></td>
        <td className="GridData2"><span className="summary">{aveSpd}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
        <td className="GridData2"><span className="summary">{max10sSpd}</span><span className="Unit2">{this.props.authUser.unit}</span></td>
        <td className="GridData2"><span className="summary">{to_d(record.pace100m_seconds)}</span></td>
        <td className="GridData2"><span className="summary">{to_d(record.pace500m_seconds)}</span></td>
        <td className="GridData2"><span className="summary">{record.stroke100m}</span></td>
        <td className="GridData2"><span className="summary">{record.stroke500m}</span></td>
      </tr>
    );
  }

  render() {

    if (!this.props.target)
      return ""

    // target はPracticeまたは選択中のLegのどちらもありえるため、
    // 常にPractice本体(全体行/Leg一覧の起点)を取得する
    const practice = this.props.target.practice || this.props.target;
    const hasLegs = practice.legs && !practice.legs.isEmpty();
    const { sortKey, sortDir } = this.state;

    let legRowData = hasLegs
      ? practice.legs.map((leg, index) => {
          const { aveSpd, max10sSpd } = calcAveAndMax10s(leg.gpses);
          return { label: `Leg${index + 1}`, record: leg, aveSpd, max10sSpd };
        })
      : [];

    if (sortKey) {
      const column = COLUMNS.find((c) => c.key === sortKey);
      const dir = sortDir === 'asc' ? 1 : -1;
      legRowData = legRowData.slice().sort((a, b) => (column.getValue(a) - column.getValue(b)) * dir);
    }

    const practiceGpses = hasLegs ? practice.gpses : [];
    const practiceAveMax10s = calcAveAndMax10s(practiceGpses);
    const practiceRow = { record: practice, ...practiceAveMax10s };

    return (
      <span>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px', gap: '8px' }}>
          {practice.session_url && (
            <Button
              variant="outline-primary"
              size="sm"
              onClick={() => practice.downloadRawData()}
              title="セッションのRAWデータ（CSV形式）をダウンロードします"
              style={{ fontWeight: 'bold' }}
            >
              <FontAwesomeIcon icon="file-csv" style={{ marginRight: '5px' }} />
              RAWデータ(CSV) DL
            </Button>
          )}
          {practice.excel_url && (
            <Button
              variant="outline-success"
              size="sm"
              onClick={() => window.open(practice.excel_url)}
              title="Excel集計データをダウンロードします"
              style={{ fontWeight: 'bold' }}
            >
              <FontAwesomeIcon icon="file-excel" style={{ marginRight: '5px' }} />
              Excel DL
            </Button>
          )}
        </div>
        <Table striped bordered hover variant="dark">
          <thead>
            <tr>
              <th></th>
              {COLUMNS.map((col) => (
                <th
                  key={col.key}
                  onClick={() => this.handleSort(col.key)}
                  style={{ cursor: 'pointer', userSelect: 'none' }}
                >
                  {col.label}{sortKey === col.key ? (sortDir === 'asc' ? ' ▲' : ' ▼') : ''}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {this.renderRow('全体', practiceRow)}
            {legRowData.map((row) => this.renderRow(row.label, row))}
          </tbody>
        </Table>
      </span>
    );
  };
}
